import React from 'react';
import { Card } from './ui/card';
import { Home, Clock, CheckCircle, Sparkles, Shield } from 'lucide-react';

const EmptyApartments = () => {
  const features = [
    { id: 'termin', icon: <Clock className="w-6 h-6" />, text: 'Schnelle Terminvergabe' },
    { id: 'sauber', icon: <Sparkles className="w-6 h-6" />, text: 'Saubere Übergabe' },
    { id: 'qualitat', icon: <Shield className="w-6 h-6" />, text: 'Weißanstrich in hoher Qualität' },
    { id: 'wohnungsabgabe', icon: <Home className="w-6 h-6" />, text: 'Perfekt für Wohnungsabgabe' },
    { id: 'fixpreis', icon: <CheckCircle className="w-6 h-6" />, text: 'Fixpreis im Voraus' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 to-blue-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Perfekt für leere Wohnungen beim Auszug
              </h2>
              <p className="text-xl text-slate-200 mb-8 leading-relaxed">
                Sie müssen Ihre Wohnung weiß gestrichen an den Vermieter übergeben? Genau darauf sind wir spezialisiert. Leere Wohnungen können besonders schnell, sauber und günstig gestrichen werden. Ideal für Mieter, Eigentümer und Hausverwaltungen.
              </p>

              <div className="space-y-4">
                {features.map((feature) => (
                  <div key={feature.id} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center text-white">
                      {feature.icon}
                    </div>
                    <span className="text-lg text-slate-100">{feature.text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1630699375895-fe5996d163ee"
                alt="Leere Wohnung"
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-green-500 text-white p-6 rounded-xl shadow-xl">
                <div className="text-3xl font-bold">ab CHF 18/m²</div>
                <div className="text-green-100">für leere Wohnungen</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmptyApartments;